import { Injectable, NgModule } from '@angular/core';
import { HttpInterceptor, HTTP_INTERCEPTORS, HttpHeaders } from '@angular/common/http';

@Injectable({providedIn:'root'})
export class InterService implements HttpInterceptor{

    constructor() {  } 
     
    intercept(req,next){
        let url = req.url;
        var url1 = window.location.href
        let method = req.method;
        let token;
        if(url.includes('authenticate') || url.includes('assets') || url.includes('signUp') || url.includes('otpSignUp') ){
            token = req.clone({
                headers : new HttpHeaders({
                  'Content-Type':'application/json',
                  'Accept':'application/json',
                  'Accept-Language':'en-US',
                  'appId':'14',
                  'organizationId':"790"
                })
            })
  
         }else  if( url.includes('forgotPassword')|| url.includes('validateResetPasswordOTP') ){
            token = req.clone({
                headers : new HttpHeaders({
                  'Content-Type':'application/json',
                  'Accept':'application/json',
                  'Accept-Language':'en-US',
                  'appId':'14',
                })
            })
  
         } else if(url.includes('notInPlace') && method != 'GET'){
            token = req.clone({
                headers : new HttpHeaders({
                    'currentUserId': localStorage.getItem('currentUserId'),
                    'hashKey':localStorage.getItem('hashKey'),
                    'Accept-Language':'en-US',
                    'organizationId':localStorage.getItem('organizationId'),
                    'appId':'14'
                })
            })
        }else if(url.includes('refDoc?deviceType')){
            token = req.clone({
                headers : new HttpHeaders({
                    'currentUserId': localStorage.getItem('currentUserId'),
                    'hashKey':localStorage.getItem('hashKey'),
                    'Accept-Language':'en-US',
                    'organizationId':sessionStorage.getItem('orgId')?sessionStorage.getItem('orgId'):localStorage.getItem('organizationId'),
                    'appId':'14'
                })
            })
        }
         else if( url.includes('newyess') && url.includes('users')){
            token = req.clone({
                headers : new HttpHeaders({
                  'Content-Type':'application/json',
                  'Accept':'application/json',
                  'Accept-Language':'en-US',
                  'currentUserId': localStorage.getItem('currentUserId'),
                  'hashKey':localStorage.getItem('hashKey'),
                  'appId':'14',
                  'organizationId':localStorage.getItem('organizationId')
                })
            })
        }else if((url.includes('smsOTP') || url.includes('validate') || url.includes('validateResetPasswordOTP'))){
            token = req.clone({
                headers : new HttpHeaders({
                  'Content-Type':'application/json',
                  'Accept':'application/json',
                  'Accept-Language':'en-US',
                  'currentUserId': localStorage.getItem('currentUserId'),
                  'hashKey':localStorage.getItem('hashKey'),
                  'appId':'14',
                  'organizationId':localStorage.getItem('organizationId')
                })
            })
        }else if((url.includes('newyess')||url.includes('basicDetails')) && !localStorage.getItem('capabilityOrg')){
            token = req.clone({
                headers : new HttpHeaders({
                  'Content-Type':'application/json',
                  'Accept':'application/json',
                  'Accept-Language':'en-US',
                  'currentUserId': '23874',
                  'hashKey':'393544e073603057fd029eb38f21931216f57af468011543707166bc541123309916b27e4058f5aa7355f99ec0e4371dd5ae9b65169f54798bdcff67e6640514',
                  'appId':'14',
                  'organizationId':'790'
                })
            })
        }
        else if(url.includes('newyess') && localStorage.getItem('capabilityOrg') && ( url.includes('docStore') || url.includes('icon'))){
            token = req.clone({
                headers : new HttpHeaders({                 
                    'currentUserId': localStorage.getItem('currentUserId'),
                    'hashKey':localStorage.getItem('hashKey'),
                    'Accept-Language':'en-US',
                    'organizationId':sessionStorage.getItem('orgId')?sessionStorage.getItem('orgId'):localStorage.getItem('organizationId'),
                    'appId':'14'
                })
            })
        }
        else if(url.includes('newyess') || url.includes('signUp') && localStorage.getItem('capabilityOrg') ){
            token = req.clone({
                headers : new HttpHeaders({
                    'Content-Type':'application/json',
                    'Accept':'application/json',
                    'currentUserId': localStorage.getItem('currentUserId'),
                    'hashKey':localStorage.getItem('hashKey'),
                    'Accept-Language':'en-US',
                    'organizationId':sessionStorage.getItem('orgId')?sessionStorage.getItem('orgId'):localStorage.getItem('organizationId'),
                    'appId':'14'
                })
            })
        }
        
        else if(url.includes('translation.googleapis.com')){
            token = req.clone({
                headers : new HttpHeaders({
                  'Content-Type':'application/json',
                  'Accept':'application/json'
                })
            })
        }
        else{
                token = req.clone({
                headers : new HttpHeaders({
                    'Content-Type':'application/json',
                    'Accept':'application/json',
                    'currentUserId': localStorage.getItem('currentUserId'),
                    'hashKey':localStorage.getItem('hashKey'),
                    'Accept-Language':'en-US',
                    'organizationId':sessionStorage.getItem('orgId')?sessionStorage.getItem('orgId'):localStorage.getItem('organizationId'),
                    'appId':'14'
                })
            })
        } 
        
        return next.handle(token)
    }
}

@NgModule({
    providers: [
        { 
         provide: HTTP_INTERCEPTORS, 
         useClass: InterService, 
         multi: true 
        }
    ]
})
export class InterceptorModule { }